// Category <title> and meta description — ONE implementation shared by the
// prerender (scripts/prerender-og.mjs) and the React page (src/pages/Category.tsx).
// The prerendered head and react-helmet's head both stay in the document, so
// they must say the same thing (they disagreed: "Folding screens and room
// dividers." vs "Shop 80 room Dividers at LoftLoom…").
//
// Copy comes only from the category's own name and description, its in-stock
// count measured at build time (src/data/categoryStock.ts) and the published
// shipping terms. Never add claims here.

/** Keep in sync with src/lib/shipping.ts (prerender-og asserts they match). */
export const CATEGORY_FREE_SHIPPING_THRESHOLD = 120;
const US_DELIVERY = "4–10 business days";

/** "Room Dividers | LoftLoom", or the category's own seoTitle. */
export function categoryHeadTitle({ name, seoTitle }) {
  return `${seoTitle || name} | LoftLoom`;
}

/** ≤ 160 characters. `inStock` is the build-time count; 0 or less omits it. */
export function categoryHeadDescription({ name, description }, inStock) {
  const head =
    inStock > 0
      ? `Browse ${Number(inStock).toLocaleString("en-US")} in-stock ${Number(inStock) === 1 ? "piece" : "pieces"} in ${name} at LoftLoom.`
      : `Browse ${name} at LoftLoom.`;
  const own = String(description || "").trim().replace(/([^.!?])$/, "$1.");
  const terms = `Free U.S. shipping over $${CATEGORY_FREE_SHIPPING_THRESHOLD}; U.S. delivery in ${US_DELIVERY}.`;
  for (const parts of [[head, own, terms], [head, terms], [head, own], [head]]) {
    const out = parts.filter(Boolean).join(" ");
    if (out.length <= 160) return out;
  }
  return head.slice(0, 157).replace(/\s+\S*$/, "") + "…";
}
